import React from 'react';
import { styled } from '@compiled/react';

import { SpotlightTarget } from '@atlaskit/onboarding';

import { ActionMenu } from '@confluence/trial-components/entry-points/ActionMenu';
import { AutoUpgradeAwarenessFreePill } from '@confluence/persistent-upgrade/entry-points/AutoUpgradeAwarenessFreePill';

import { useEditionAwarenessDataQueries } from './useDataQueries';
import { EditionAwarenessAudienceTimingChecker } from './AudienceTimingChecker';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'none',
	'@media (min-width: 680px)': {
		display: 'initial',
	},
});

export const EditionAwareness = () => {
	const data = useEditionAwarenessDataQueries();

	return (
		<EditionAwarenessAudienceTimingChecker data={data}>
			{({ shouldRenderTrial, shouldRenderFree }) => (
				<SpotlightTarget name="edition-awareness">
					<Container>
						{shouldRenderFree ? (
							<AutoUpgradeAwarenessFreePill />
						) : (
							shouldRenderTrial && <ActionMenu />
						)}
					</Container>
				</SpotlightTarget>
			)}
		</EditionAwarenessAudienceTimingChecker>
	);
};
